import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const allowedApis = [
      '/api/CheckDomainEnabledForSSO'
    ];

    const isTargetedApi = allowedApis.some(api => req.url.includes(api));

    if (isTargetedApi) {
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status !== 200) {
            this.router.navigate(['/application-down']);
          }
          return throwError(error);
        })
      );
    }

    return next.handle(req);
  }
}
